var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBusIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36851 15.3474C1.80009 14.8737 1.42114 14.1158 1.42114 13.2632V3.78947C1.42114 0.473684 4.83167 0 9.00009 0C13.1685 0 16.579 0.473684 16.579 3.78947V13.2632C16.579 14.1158 16.2001 14.8737 15.6317 15.3474V17.0526C15.6317 17.6211 15.2527 18 14.6843 18H13.7369C13.1685 18 12.7896 17.6211 12.7896 17.0526V16.1053H5.21062V17.0526C5.21062 17.6211 4.83167 18 4.26325 18H3.31588C2.74746 18 2.36851 17.6211 2.36851 17.0526V15.3474ZM3.31588 12.7895C3.31588 13.5474 3.97904 14.2105 4.73693 14.2105C5.49483 14.2105 6.15798 13.5474 6.15798 12.7895C6.15798 12.0316 5.49483 11.3684 4.73693 11.3684C3.97904 11.3684 3.31588 12.0316 3.31588 12.7895ZM13.2632 14.2105C12.5054 14.2105 11.8422 13.5474 11.8422 12.7895C11.8422 12.0316 12.5054 11.3684 13.2632 11.3684C14.0211 11.3684 14.6843 12.0316 14.6843 12.7895C14.6843 13.5474 14.0211 14.2105 13.2632 14.2105ZM3.31588 8.52632H14.6843V3.78947H3.31588V8.52632Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBusIconBlack);
export default __webpack_public_path__ + "static/media/ic_bus_icon_black.a50d3e2a093e5fe024dd5c50922aed97.svg";
export { ForwardRef as ReactComponent };